<template>
  <div class="mt-4">
    <new-invoice-sheet :loading="loading" headtitle="新增訂單" :submitFunc="submit"/>
  </div>
</template>

<script>
import NewInvoiceSheet from '@/components/NewInvoiceSheet.vue'
import { invoices } from '@/api'
import _ from 'lodash'

export default {
  name: 'new-invoice',
  data () {
    return {
      loading: false
    }
  },
  methods: {
    submit(d) {
      let data = d
      this.loading = true

      invoices.post(null, data, {}).then(response => {
        let invoice_id = response.data.invoice_id
        this.loading = false
        this.$router.push({name:'view', params: {invoice_id: invoice_id}})
      }).catch((err) => {
        this.loading = false
        console.log(err)
      })
    }
  },
  components: {
    NewInvoiceSheet
  }
}
</script>

<style scoped>
.input_sheet {
  height: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/views/NewInvoice.vue